<template>
    <div class="top-spacer"></div>
    <div class="image-wrapper">
        <img src="@/images/u572.png" alt="项目图片" />
    </div>
    <div style="margin:0 auto;text-align: center;">
        <h1>弹性的工作时间，美味的茶点和小零食，丰富多彩的社团活动……</h1>
        <h2 style="color: #949494;">我们期待你的加入</h2>
    </div>
    <div class="background">
        <span>简历投递通道邮箱：hzgf@digit-core.com</span>
    </div>
    <div v-for="(item,index) in Post" :key="index" class="Post">
        <div class="Post_title">
            <img class="Post_ico" src="@/images/ico/u577.png" alt="">
            <h1>{{item.PostTitle}}</h1>
        </div>
        <ul class="Post_ul">
            {{item.PostDuty}}
            <li v-for="(item,index) in item.PostDutytext" :key="index"  class="Post_li"> {{index+1}}:{{item}}</li>
        </ul>
        <ul class="Post_ul">
            任职资格
            {{item.qualification}}
            <li v-for="(item,index) in item.qualificationText" :key="index" class="Post_li"> {{index+1}}:{{item}}</li>
        </ul>
    
    
    </div>
</template>

<script>
export default {
  data() {
    return {
      Post: [{
        PostTitle: '产品方案工程师',
        PostDuty: '岗位职责',
        PostDutytext: [
          '负责仓储项目的规划设计及售前技术支持;',
          '负责客户仓储相关需求调研、收集及分析；',
          '负责仓储集成规划方案的说明文档编写及汇报；',
          '负责大型仓储设备选型及招标工作；',
          '负责项目的实施计划', '负责上级领导安排的其他工作'],
        qualification: '任职资格',
        qualificationText: [
          '仓储、物流相关行业，3年以上仓储、物流项目管理工作经验；',
          '有仓储规划、售前、库存管理、运输和配送优化相关的实践经验；',
          '具有仓储设备（自动化立体仓库、堆垛机、输送分拣线、AGV、机械手等）技术方案制作、设备图纸细化、分段设计、设备参数选择等相关经验；',
          '熟练操作proe、solidworks、ug等三维软件及应用办公软件'
        ]
      },{
        PostTitle: '高级Java开发工程师',
        PostDuty: '岗位职责',
        PostDutytext: [
          '负责仓储项目的规划设计及售前技术支持;',
          '负责客户仓储相关需求调研、收集及分析；',
          '负责仓储集成规划方案的说明文档编写及汇报；',
          '负责大型仓储设备选型及招标工作；',
          '负责项目的实施计划', '负责上级领导安排的其他工作'],
        qualification: '任职资格',
        qualificationText: [
          '仓储、物流相关行业，3年以上仓储、物流项目管理工作经验；',
          '有仓储规划、售前、库存管理、运输和配送优化相关的实践经验；',
          '具有仓储设备（自动化立体仓库、堆垛机、输送分拣线、AGV、机械手等）技术方案制作、设备图纸细化、分段设计、设备参数选择等相关经验；',
          '熟练操作proe、solidworks、ug等三维软件及应用办公软件'
        ]
      },{
        PostTitle: '激光感知算法工程师',
        PostDuty: '岗位职责',
        PostDutytext: [
          '负责仓储项目的规划设计及售前技术支持;',
          '负责客户仓储相关需求调研、收集及分析；',
          '负责仓储集成规划方案的说明文档编写及汇报；',
          '负责大型仓储设备选型及招标工作；',
          '负责项目的实施计划', '负责上级领导安排的其他工作'],
        qualification: '任职资格',
        qualificationText: [
          '仓储、物流相关行业，3年以上仓储、物流项目管理工作经验；',
          '有仓储规划、售前、库存管理、运输和配送优化相关的实践经验；',
          '具有仓储设备（自动化立体仓库、堆垛机、输送分拣线、AGV、机械手等）技术方案制作、设备图纸细化、分段设计、设备参数选择等相关经验；',
          '熟练操作proe、solidworks、ug等三维软件及应用办公软件'
        ]
      },{
        PostTitle: '高级硬件工程师',
        PostDuty: '岗位职责',
        PostDutytext: [
          '负责仓储项目的规划设计及售前技术支持;',
          '负责客户仓储相关需求调研、收集及分析；',
          '负责仓储集成规划方案的说明文档编写及汇报；',
          '负责大型仓储设备选型及招标工作；',
          '负责项目的实施计划', '负责上级领导安排的其他工作'],
        qualification: '任职资格',
        qualificationText: [
          '仓储、物流相关行业，3年以上仓储、物流项目管理工作经验；',
          '有仓储规划、售前、库存管理、运输和配送优化相关的实践经验；',
          '具有仓储设备（自动化立体仓库、堆垛机、输送分拣线、AGV、机械手等）技术方案制作、设备图纸细化、分段设计、设备参数选择等相关经验；',
          '熟练操作proe、solidworks、ug等三维软件及应用办公软件'
        ]
      },{
        PostTitle: 'KA销售/商务经理',
        PostDuty: '岗位职责',
        PostDutytext: [
          '负责仓储项目的规划设计及售前技术支持;',
          '负责客户仓储相关需求调研、收集及分析；',
          '负责仓储集成规划方案的说明文档编写及汇报；',
          '负责大型仓储设备选型及招标工作；',
          '负责项目的实施计划', '负责上级领导安排的其他工作'],
        qualification: '任职资格',
        qualificationText: [
          '仓储、物流相关行业，3年以上仓储、物流项目管理工作经验；',
          '有仓储规划、售前、库存管理、运输和配送优化相关的实践经验；',
          '具有仓储设备（自动化立体仓库、堆垛机、输送分拣线、AGV、机械手等）技术方案制作、设备图纸细化、分段设计、设备参数选择等相关经验；',
          '熟练操作proe、solidworks、ug等三维软件及应用办公软件'
        ]
      },{
        PostTitle: '商务BD',
        PostDuty: '岗位职责',
        PostDutytext: [
          '负责仓储项目的规划设计及售前技术支持;',
          '负责客户仓储相关需求调研、收集及分析；',
          '负责仓储集成规划方案的说明文档编写及汇报；',
          '负责大型仓储设备选型及招标工作；',
          '负责项目的实施计划', '负责上级领导安排的其他工作'],
        qualification: '任职资格',
        qualificationText: [
          '仓储、物流相关行业，3年以上仓储、物流项目管理工作经验；',
          '有仓储规划、售前、库存管理、运输和配送优化相关的实践经验；',
          '具有仓储设备（自动化立体仓库、堆垛机、输送分拣线、AGV、机械手等）技术方案制作、设备图纸细化、分段设计、设备参数选择等相关经验；',
          '熟练操作proe、solidworks、ug等三维软件及应用办公软件'
        ]
      },
      ]
    };
  }
};
</script>
<style scoped>
.Post_ul {
    list-style-type: none;
    font-size: 30px;
}

.Post_li {
    font-size: 20px;
}

.top-spacer {
    height: 80px;
    width: 100%;
}

.image-wrapper {
    width: 100%;
    padding: 0;
    margin: 0;
}

.image-wrapper img {
    width: 100%;
    height: auto;
    display: block;

}

.background {
    width: 380px;
    height: 50px;
    background-color: aqua;
    margin: 0 auto;
    border-radius: 50px;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
}

.Post_ico {
    width: 64px;
    height: 64px;
    margin-right: 20px;
}

.Post_title {
    display: flex;
    align-items: center;
}
.Post{
    width: 60%;
    margin: 0 auto;
}
</style>